import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import { getParRateFormulaByType, getParRateFormulaByTypeParams, ParRateFormulaByTypeResponse } from 'services/parametersService';


export type PricingListSelectProps = SelectProps<any> &{
  params: getParRateFormulaByTypeParams;
  value?:   ParRateFormulaByTypeResponse;
  onChange?: (formularate?:ParRateFormulaByTypeResponse) => void;
  onSelected?: (formularate: ParRateFormulaByTypeResponse) => void;

  disabled?: boolean;
  allowClear?:boolean;
  style?: any;
};

const RateFormulaSelect = ({
  params,
  value,
  onChange = noop,
  onSelected,
  ...otherProps
}: PricingListSelectProps) => {
  const { data: formularate,isLoading } = useQuery(
    ['getParRateFormulaByType', params],
    () => getParRateFormulaByType(params).then((res) => res.list || []),
    { enabled: !!params.formulatype }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(formularate?.find((item) => item.formulacode === value)!);
    }
  };
  return (
    <Select onChange={handleChange} value={value} {...otherProps} loading={isLoading} allowClear>
      {formularate?.map((formularate) => (
        <Select.Option value={formularate.formulacode} key={formularate.formulacode}>
          {formularate.formulalabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default RateFormulaSelect;
